var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-layout"},[_c('mobile-header'),_c('div',{staticClass:"mobile-layout-content"},[_c('transition',{attrs:{"name":_vm.transition,"mode":"out-in","duration":100}},[_c('router-view')],1)],1),_c('prd-notify-wrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }